<template>
	<form>
		<p>It only takes a moment to make someone’s day!</p>
		<base-input @click.native.prevent="hideBouncingArrow" type="text" name="name" v-model="name" v-validate="'required'">Who is this message for? (Name)</base-input>
		<base-input @click.native.prevent="hideBouncingArrow" type="email" name="email" :validate="'email'" v-model="email">What is their email address? (Optional)</base-input>
		<div :class="{'form-input': true, 'error' : errors.has('message'), 'no-empty': message.length > 0}">
			<textarea @click.prevent="hideBouncingArrow" name="message" id="message" required v-validate="{required: true, max: maxlength}" :maxlength="maxlength" v-model="message"></textarea>
			<label for="message">Say something nice!</label>
			<span class="textarea__counter">{{message.length}}/{{maxlength}}</span>
		</div>
		<p class="error-message" v-if="errorMessage">
			{{errorMessage}}
		</p>
		<div class="buttons buttons--next-only">
			<button-right @click.native.prevent="submit" :class="{loading: formLoading}">Next</button-right>
		</div>
	</form>
</template>

<script>
import axios from 'axios';
import * as constants from '@/constants';
import ButtonRight from '../ButtonRight';
import ButtonLeft from '../ButtonLeft';
import BaseInput from '../BaseInput';

export default {
	$_veeValidate: {
		validator: 'new', // give me a new validator each time.
	},
	components: { ButtonRight, ButtonLeft, BaseInput },
	data () {
		return {
			formLoading: false,
			profanityError: false,
			errorMessage: null,
			maxlength: 144,
			name: '',
			email: '',
			message: '',
		};
	},
	watch: {
		name (newVar) {
			this.$store.commit('formMessage', {
				name: this.name,
				message: this.message,
			});
		},
		message (newVar) {
			this.$store.commit('formMessage', {
				name: this.name,
				message: this.message,
			});
		},
	},
	mounted () {
		this.name = this.$store.getters.debug ? 'Test name' : this.$store.state.form.to.name;
		this.email = this.$store.getters.debug ? 'email@test.tld' : this.$store.state.form.to.email;
		this.message = this.$store.getters.debug ? 'Test message' : this.$store.state.form.to.message;
	},
	methods: {
		async submit (e) {
			try {
				this.formLoading = true;

				const validation = await this.$validator.validateAll();
				if (!validation) {
					throw Error('There has been an error with your details, please review and try again.');
				}

				this.$store.commit('formMessage', {
					name: this.name,
					email: this.email,
					message: this.message,
				});
				this.$emit('success');
			} catch (error) {
				console.warn(error);
				this.errorMessage = error.message;
			}
			this.formLoading = false;
		},

		/**
		 * Hide the bouncing arrow.
		 */
		hideBouncingArrow () {
			if (this.$store.state.bouncingArrow) {
				this.$store.commit('bouncingArrow', false);
			}
		},
	},
};
</script>

<style lang=less scoped>
	@import (reference) '../../assets/less/default.less';
	@import '../../assets/less/form.less';
	@import '../../assets/less/form-input.less';

	form { padding: 1rem; text-align: left; }
	p { margin-left: auto; margin-right: auto; max-width: 70%; padding-left: 1rem; text-align: center; }
	.textarea__counter { .bottom-right(); display: block; padding: 3px; background-color: #fff; color: fade(@grey, 50); font-size: 0.5rem; }

	@media @mobile {
		form { padding: 6vw 3vw 12vw; }
	}
</style>



// WEBPACK FOOTER //
// src/components/TheForm/TheFormMessage.vue